export const emailReducer = (state, action) => {
  const { type, payload } = action;
  switch (type) {
    case 'FILTER':
      return {
        ...state,
        currentFilter: payload,
        emails: state.allEmails.filter(email => {
          if (payload === 'all') {
            return true;
          } else if (payload === 'unread') {
            return !email.read;
          } else {
            return email[payload];
          }
        })
      };

    case 'FILTER_SENT':
      return {
        ...state,
        currentSentFilter: payload,
        sentEmails: state.allSentEmails.filter(email => {
          if (payload === 'all') {
            return true;
          }
          // Add other sent email filters as needed
          return true;
        })
      };

    case 'BULK_UPDATE':
      return {
        ...state,
        allEmails: state.allEmails.map(email =>
          payload.ids.includes(email.id)
            ? { ...email, [payload.key]: payload.value }
            : email
        )
      };

    case 'ARCHIVE':
      return {
        ...state,
        allEmails: state.allEmails.map(email =>
          payload.includes(email.id) ? { ...email, archive: true } : email
        ),
        emails: state.emails.filter(email => !payload.includes(email.id))
      };

    case 'DELETE':
      return {
        ...state,
        allEmails: state.allEmails.filter(email => !payload.includes(email.id)),
        emails: state.emails.filter(email => !payload.includes(email.id))
      };

    case 'DELETE_SENT':
      return {
        ...state,
        allSentEmails: state.allSentEmails.filter(email => !payload.includes(email.id ?? email.messageId)),
        sentEmails: state.sentEmails.filter(email => !payload.includes(email.id ?? email.messageId))
      };

    case 'READ':
      return {
        ...state,
        emails: state.emails.map(email =>
          payload.includes(email.id) ? { ...email, read: !email.read } : email
        )
      };

    case 'SNOOZE':
      return {
        ...state,
        allEmails: state.allEmails.map(email =>
          payload.includes(email.id) ? { ...email, snooze: true } : email
        )
      };

    case 'SET_SENT_EMAILS':
      return {
        ...state,
        sentEmails: payload,
        allSentEmails: payload,
        currentSentFilter: 'all'
      };

    case 'ADD_SENT_EMAIL':
      return {
        ...state,
        sentEmails: [payload, ...state.sentEmails],
        allSentEmails: [payload, ...state.allSentEmails]
      };

    case 'SET_USERS':
      return {
        ...state,
        users: payload
      };

    case 'SET_LOADING':
      return {
        ...state,
        loading: payload
      };

    case 'SET_ERROR':
      return {
        ...state,
        error: payload
      };

    case 'RESET':
      return {
        ...state,
        emails: state.allEmails,
        currentFilter: 'all'
      };

    case 'RESET_SENT':
      return {
        ...state,
        sentEmails: state.allSentEmails,
        currentSentFilter: 'all'
      };

    default:
      return state;
  }
};